import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiClock } from "react-icons/fi";
import { Card, Col, Row } from "react-bootstrap";
import { formatCurrency } from "utils/number";
import { hasAutoApprovalLinkRequestsFeature } from "store/selectors/employer";
import type { RootState } from "types/state";

import Button from "components/Button";

import "./EmployerDashboard.scss";

interface OwnProps {
  numOfPendingApprovals: number;
  totalAmount: number;
  linkedEmployees: number;
}

const mapStateToProps = (state: RootState) => {
  return {
    hasAutoApprovalFeature: hasAutoApprovalLinkRequestsFeature(state),
  };
};

const mapDispatchToProps = { push };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

type State = Record<string, never>;

class TotalsTable extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <Card className="dashboard-widget">
          <div
            className="widget-header"
            style={{
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <span>
              <Card.Title>Totals</Card.Title>
            </span>
            {!this.props.hasAutoApprovalFeature && (
              <Button
                size="sm"
                name="action"
                color="action"
                icon={{
                  icon: <FiClock size={14} color={"#fffff"} />,
                  position: "left",
                }}
                onClick={() => {
                  this.props.push(`/dashboard/company/group`);
                }}
                btnLabel="See pending approvals"
              />
            )}
          </div>
          <div className="enrollment-table">
            <Row>
              <Col className="enrollment">
                <span className="enrollment-description">
                  <p className="enrollment-label">
                    Total Participant Contributions
                  </p>
                  <p className="enrollment-value">
                    {formatCurrency(this.props.totalAmount)}
                  </p>
                </span>
              </Col>

              <Col className="enrollment">
                <span className="enrollment-description">
                  <p className="enrollment-label">Current Participants</p>
                  <p className="enrollment-value">
                    {this.props.linkedEmployees}
                  </p>
                </span>
              </Col>

              <Col className="enrollment">
                <span className="enrollment-description">
                  <p className="enrollment-label">New Participant Approvals</p>
                  <p className="enrollment-value">
                    {this.props.numOfPendingApprovals}
                  </p>
                </span>
              </Col>
            </Row>
          </div>
        </Card>
      </>
    );
  }
}

export default connector(withApollo<Props>(TotalsTable));
